import axios from 'axios';
const Url = process.env.NODE_ENV === 'development' ? '/api' : 'https://unimaisead.com.br/api';

const axiosInstance = axios.create({
        baseURL: Url, // 👈 proxy redireciona isso para o backend
        headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
        },
});

const request = {
        post: function (url, data) {
                return axiosInstance.post(url, data, {
                        headers: {
                                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        },
                });
        },
        get: function (url) {
                return axiosInstance.get(url, {
                        // params: params,
                        headers: {
                                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        },
                });
        }
};

export default request;
export { Url };